var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "record") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "programs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "record",
    transform: "translate(-37.000000, -182.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8388,4.62733333 C16.8205125,4.58319583 16.7937458,4.54309167 16.7599667,4.50926667 L12.3599667,0.109266667 C12.3261417,0.0754875 12.2860375,0.0487208333 12.2419,0.0304333333 C12.1971208,0.0109541667 12.1488583,0.000595833333 12.1,0 L0.366666667,0 C0.164175,0 0,0.164175 0,0.366666667 L0,21.6333333 C0,21.835825 0.164175,22 0.366666667,22 L16.5,22 C16.7024917,22 16.8666667,21.835825 16.8666667,21.6333333 L16.8666667,4.76666667 C16.8666667,4.7188625 16.8570875,4.67151667 16.8388,4.62733333 Z M12.4666667,1.2518 L15.6148667,4.4 L12.4666667,4.4 L12.4666667,1.2518 Z M16.1333333,21.2666667 L0.733333333,21.2666667 L0.733333333,0.733333333 L11.7333333,0.733333333 L11.7333333,4.76666667 C11.7333333,4.96915833 11.8975083,5.13333333 12.1,5.13333333 L16.1333333,5.13333333 L16.1333333,21.2666667 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,5.5 L3.3,5.5 L3.3,6.6 C3.3,6.80249167 3.464175,6.96666667 3.66666667,6.96666667 L5.13333333,6.96666667 C5.335825,6.96666667 5.5,6.80249167 5.5,6.6 L5.5,5.5 L6.6,5.5 C6.80249167,5.5 6.96666667,5.335825 6.96666667,5.13333333 L6.96666667,3.66666667 C6.96666667,3.464175 6.80249167,3.3 6.6,3.3 L5.5,3.3 L5.5,2.2 C5.5,1.99750833 5.335825,1.83333333 5.13333333,1.83333333 L3.66666667,1.83333333 C3.464175,1.83333333 3.3,1.99750833 3.3,2.2 L3.3,3.3 L2.2,3.3 C1.99750833,3.3 1.83333333,3.464175 1.83333333,3.66666667 L1.83333333,5.13333333 C1.83333333,5.335825 1.99750833,5.5 2.2,5.5 Z M2.56666667,4.03333333 L3.66666667,4.03333333 C3.86915833,4.03333333 4.03333333,3.86915833 4.03333333,3.66666667 L4.03333333,2.56666667 L4.76666667,2.56666667 L4.76666667,3.66666667 C4.76666667,3.86915833 4.93084167,4.03333333 5.13333333,4.03333333 L6.23333333,4.03333333 L6.23333333,4.76666667 L5.13333333,4.76666667 C4.93084167,4.76666667 4.76666667,4.93084167 4.76666667,5.13333333 L4.76666667,6.23333333 L4.03333333,6.23333333 L4.03333333,5.13333333 C4.03333333,4.93084167 3.86915833,4.76666667 3.66666667,4.76666667 L2.56666667,4.76666667 L2.56666667,4.03333333 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83333333,11 C1.83333333,11.2024917 1.99750833,11.3666667 2.2,11.3666667 L14.6666667,11.3666667 C14.8691583,11.3666667 15.0333333,11.2024917 15.0333333,11 C15.0333333,10.7975083 14.8691583,10.6333333 14.6666667,10.6333333 L2.2,10.6333333 C1.99750833,10.6333333 1.83333333,10.7975083 1.83333333,11 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,12.8333333 L2.2,12.8333333 C1.99750833,12.8333333 1.83333333,12.9975083 1.83333333,13.2 C1.83333333,13.4024917 1.99750833,13.5666667 2.2,13.5666667 L14.6666667,13.5666667 C14.8691583,13.5666667 15.0333333,13.4024917 15.0333333,13.2 C15.0333333,12.9975083 14.8691583,12.8333333 14.6666667,12.8333333 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,15.0333333 L2.2,15.0333333 C1.99750833,15.0333333 1.83333333,15.1975083 1.83333333,15.4 C1.83333333,15.6024917 1.99750833,15.7666667 2.2,15.7666667 L14.6666667,15.7666667 C14.8691583,15.7666667 15.0333333,15.6024917 15.0333333,15.4 C15.0333333,15.1975083 14.8691583,15.0333333 14.6666667,15.0333333 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,17.2333333 L2.2,17.2333333 C1.99750833,17.2333333 1.83333333,17.3975083 1.83333333,17.6 C1.83333333,17.8024917 1.99750833,17.9666667 2.2,17.9666667 L14.6666667,17.9666667 C14.8691583,17.9666667 15.0333333,17.8024917 15.0333333,17.6 C15.0333333,17.3975083 14.8691583,17.2333333 14.6666667,17.2333333 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramInfo);
export default __webpack_public_path__ + "static/media/programInfo.224eb77e31b364008885a81965d474aa.svg";
export { ForwardRef as ReactComponent };